<template>
  <div class="loading">
    <div id="lottie"></div>
  </div>
</template>



<script>
import lottie from "lottie-web"
import animationData from '@/assets/images/loading.json'
export default {
  name: "",
  data() {
    return {
      animation: null
    }
  },
  components: {
  },
  computed: {},
  watch: {},
  methods: {
    init() {
      this.animation = lottie.loadAnimation({
        container: document.getElementById("lottie"),
        renderer: "svg",
        loop: true,   //循环播放 true/number/false
        autoplay: true,
        animationData
      });
    }
  },
  created() {
  },
  mounted(){
    this.init()
  }
}
</script>

<style scoped lang="less">
.loading {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  z-index: 999999;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 3.1rem;
    height: 1.4rem;
  }
}
</style>